import Image from 'next/image'
import { FunctionComponent } from 'react'
import FacebookSrc from '@/assets/images/platform-brand/facebook.png'
import InstagramSrc from '@/assets/images/platform-brand/instagram.png'
import TiktokSrc from '@/assets/images/platform-brand/tiktok.png'
import TwitterSrc from '@/assets/images/platform-brand/twitter.png'
import YoutubeSrc from '@/assets/images/platform-brand/youtube.png'
import { PlatformShortcode } from '@/utils/convert-platform'
import { PptxObjectType } from '@/utils/export-pptx/constants'

interface PlatformImageProps {
  platform: PlatformShortcode
  width: number
  height: number
}

const PlatformImage: FunctionComponent<PlatformImageProps> = ({
  platform,
  width,
  height,
}) => {
  if (platform === PlatformShortcode.Instagram) {
    return (
      <Image
        alt='Instagram'
        data-pptx-object={PptxObjectType.Image}
        height={height}
        src={InstagramSrc}
        width={width}
      />
    )
  }
  if (platform === PlatformShortcode.Facebook) {
    return (
      <Image
        alt='Facebook'
        data-pptx-object={PptxObjectType.Image}
        height={height}
        src={FacebookSrc}
        width={width}
      />
    )
  }
  if (platform === PlatformShortcode.YouTube) {
    return (
      <Image
        alt='Youtube'
        data-pptx-object={PptxObjectType.Image}
        height={height}
        src={YoutubeSrc}
        width={width}
      />
    )
  }
  if (platform === PlatformShortcode.Twitter) {
    return (
      <Image
        alt='Twitter'
        data-pptx-object={PptxObjectType.Image}
        height={height}
        src={TwitterSrc}
        width={width}
      />
    )
  }
  if (platform === PlatformShortcode.TikTok) {
    return (
      <Image
        alt='Tiktok'
        data-pptx-object={PptxObjectType.Image}
        height={height}
        src={TiktokSrc}
        width={width}
      />
    )
  }
}

export default PlatformImage
